import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { Globe, MapPin, Building2, Plug } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const CaseStudyOverview = () => {
  const { ref, isVisible } = useScrollAnimation();
  const { t } = useLanguage();
  const p = "caseStudyBgeh.overview";
  const icons = [Building2, Globe, MapPin, Plug];
  const keys = ["company", "website", "location", "features"];
  return (
    <section ref={ref as React.RefObject<HTMLElement>} className={cn("py-16 md:py-24 transition-all duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="md:col-span-1">
              <h2 className="text-sm font-semibold text-chathero-mint uppercase tracking-wider mb-6">{t(`${p}.atAGlance`)}</h2>
              <div className="space-y-6">
                {keys.map((key, index) => { const Icon = icons[index]; return (
                  <div key={index} className="flex gap-3">
                    <div className="w-10 h-10 rounded-lg bg-secondary flex items-center justify-center flex-shrink-0"><Icon className="w-5 h-5 text-chathero-mint" /></div>
                    <div>
                      <div className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-1">{t(`${p}.${key}`)}</div>
                      {key === "website" ? (
                        <a href={`https://${t(`${p}.${key}Value`)}`} target="_blank" rel="noopener noreferrer" className="text-sm text-chathero-mint hover:underline">{t(`${p}.${key}Value`)}</a>
                      ) : (
                        <div className="text-sm text-foreground">{t(`${p}.${key}Value`)}</div>
                      )}
                    </div>
                  </div>
                ); })}
              </div>
            </div>
            <div className="md:col-span-2">
              <h2 className="text-2xl md:text-3xl font-bold text-primary mb-6">{t(`${p}.storyTitle`)}</h2>
              <div className="prose prose-lg text-muted-foreground">
                <p className="mb-4">{t(`${p}.storyP1`)}</p>
                <p className="mb-4">{t(`${p}.storyP2`)}</p>
                <p>{t(`${p}.storyP3`)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default CaseStudyOverview;
